let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ioZNk")).then(() => parcelRequire('fd2lp'));